var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChannelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9091 54.4848C42.1137 54.4848 52.8181 43.7803 52.8181 30.5757C52.8181 17.3711 42.1137 6.66663 28.9091 6.66663C15.7045 6.66663 5 17.3711 5 30.5757C5 43.7803 15.7045 54.4848 28.9091 54.4848Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.909 21.8711C31.3064 21.8711 33.2499 19.9276 33.2499 17.5302C33.2499 15.1328 31.3064 13.1893 28.909 13.1893C26.5116 13.1893 24.5681 15.1328 24.5681 17.5302C24.5681 19.9276 26.5116 21.8711 28.909 21.8711Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8636 34.9167C18.261 34.9167 20.2045 32.9732 20.2045 30.5758C20.2045 28.1784 18.261 26.2349 15.8636 26.2349C13.4662 26.2349 11.5227 28.1784 11.5227 30.5758C11.5227 32.9732 13.4662 34.9167 15.8636 34.9167Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3409 47.6818C31.7383 47.6818 33.6818 45.7383 33.6818 43.3409C33.6818 40.9435 31.7383 39 29.3409 39C26.9435 39 25 40.9435 25 43.3409C25 45.7383 26.9435 47.6818 29.3409 47.6818Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3409 35.6818C44.7383 35.6818 46.6818 33.7383 46.6818 31.3409C46.6818 28.9435 44.7383 27 42.3409 27C39.9435 27 38 28.9435 38 31.3409C38 33.7383 39.9435 35.6818 42.3409 35.6818Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9998 54.4847H28.9089",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 30.5759H31.0909",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelIcon);
export default __webpack_public_path__ + "static/media/ChannelIcon.8e1185f510c791371dc23e4566d8e0da.svg";
export { ForwardRef as ReactComponent };